import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { createAttendeePoint, updateAttendeePoint, deleteAttendeePoint } from '@/redux/actions';

const WS_POINTS_BY_HTTP = {
	CREATE: 'event/:eventID/point/attendee/:attendeeID/POST',
	UPDATE: 'event/:eventID/point/attendee/:attendeeID/PATCH',
	DELETE: 'event/:eventID/point/attendee/:attendeeID/DELETE',
};

const AttendePointsSubscriptions = props => {
	const { socket, attendee, createAttendeePoint, updateAttendeePoint, deleteAttendeePoint } = props;
	const { id: attendeeID, first_name, last_name } = attendee;
	const propsToSend = { ...props };
	delete propsToSend.children;
	const subscribe = () => {
		console.log('⚡️ AttendeePointsSubscription Mounted ⚡️');
		socket.emit('event/:eventID/point/attendee/:attendeeID/SUBSCRIBE', { attendeeID });
	};

	const unsubscribe = () => {
		console.log(`🚶‍♂️ AttendeePointsSubscription Unmounted 🚶‍♂️`);
		socket.emit('event/:eventID/point/attendee/:attendeeID/UNSUBSCRIBE', { attendeeID });
	};

	const listenForCreatedAttendeePoint = () =>
		socket.on(WS_POINTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating points', error);
			else {
				createAttendeePoint(data);
				displayMessage(`Points given to ${first_name} ${last_name}`);
			}
		});

	const listenForUpdatedAttendeePoint = () => {
		socket.on(WS_POINTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating points', error);
			else {
				updateAttendeePoint(data);
				displayMessage(`Points updated`);
			}
		});
	};

	const listenForDeletedAttendeePoint = () => {
		socket.on(WS_POINTS_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating points', error);
			else {
				deleteAttendeePoint(data);
				displayMessage(`Points deleted`);
			}
		});
	};

	const listeners = () => [
		listenForCreatedAttendeePoint,
		listenForUpdatedAttendeePoint,
		listenForDeletedAttendeePoint,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_POINTS_BY_HTTP)}
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = state => ({
	socket: state.ws.socket,
	auth0Token: state.auth.auth0Token,
});

const mdp = dispatch => ({
	createAttendeePoint: attendeePoint => dispatch(createAttendeePoint(attendeePoint)),
	updateAttendeePoint: attendeePoint => dispatch(updateAttendeePoint(attendeePoint)),
	deleteAttendeePoint: attendeePoint => dispatch(deleteAttendeePoint(attendeePoint)),
});

export default connect(msp, mdp)(AttendePointsSubscriptions);
